import axios from 'axios';
import React, { useState, useMemo } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup } from 'reactstrap';
import { Label } from 'reactstrap'
import { environment } from '../../env';
import { successModalToggle, loaderAction } from '../../redux/actions/Index';
import ErrorComponents from '../errorComponents/ErrorComponents';
import { useEffect } from 'react';
import { ArrowsClockwise } from '@phosphor-icons/react';
import { toast } from 'react-toastify';

const ForgotPassword = ({ datas, userLists, title, button, getAllUser }, ...props) => {
    const [modal, setModal] = useState(false);
    const [editt, setEdit] = useState(false)
    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const [psserr, setPsserr] = useState('')
    const [nameFilters, setNameFilters] = useState()
    const [passwordToggle2, setPasswordToggle2] = useState(true)
    const [eyeIcon2, setEyeIcon2] = useState('fa-eye');
    const [eyeIcon3, setEyeIcon3] = useState('fa-eye');
    const [passwordToggle3, setPasswordToggle3] = useState(true)
    const toggle = () => { setModal(!modal); setEdit(!editt) }
    const dispatch = useDispatch()
    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm();

    const userName = watch("fusername")

    const submitt = async (data) => {
        console.log(data);
        if (data.fpassword != data.fpassword2) {
            setPsserr("Passwords do not match");
            return
        } else {
            setPsserr('')
        }
        try {
            await axios.post(`${environment.baseUrl}forgot-password/`, data).then((response) => {
                if (response.data.code == 200) {
                    toggle();
                    toast.success("Password Updated Successfully")
                }
                else if (response.data.code == 500) {
                    if (response.data.message) {
                        setregistererror(response.data.message)
                    } else if (response.data.message) {
                        setregistererror(response.data.message)
                    } else {
                    }
                }
            })
        }
        catch (err) {
            console.log(err);
        }
    }

    // const getProjectData = () => {
    //     try {
    //         axios.get(`${environment.baseUrl}project/`).then(res => setProjectList(res?.data)).catch(res => {
    //             console.log("error", res);
    //         })
    //     }
    //     catch (err) {
    //         console.log(err);
    //     }
    // };
    const CancelButton = () => {
        toggle();
        reset();
        setNameFilters("");
    }

    useMemo(() => {
        if (button == 'edit') {
            reset({
                "first_name": datas?.user?.first_name,
                "last_name": datas?.user?.last_name,
                "fusername": datas?.user?.username,
                "email": datas?.user?.email,
                "role": datas?.role,
                "project": datas?.project?.id,
            })
        }
    }, [editt])


    const passwordShow2 = () => {
        setPasswordToggle2(!passwordToggle2);
        if (eyeIcon2 == 'fa-eye') {
            setEyeIcon2("fa-eye-slash");
        } else {
            setEyeIcon2("fa-eye");
        }
    }
    const passwordShow3 = () => {
        setPasswordToggle3(!passwordToggle3);
        if (eyeIcon3 == 'fa-eye') {
            setEyeIcon3("fa-eye-slash");
        } else {
            setEyeIcon3("fa-eye");
        }
    }

    // useEffect(() => {
    //     getProjectData()
    // }, [])


    return (
        <>
            {
                <button
                    onClick={toggle}
                    className="icon-bg-red border-0 px-2 py-3 rounded"><ArrowsClockwise size="26" className='icon-color-red' />
                </button>
            }
            <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="lg" centered>
                <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>Reset Password</span></ModalHeader>
                <Form onSubmit={handleSubmit(submitt)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row">
                            <FormGroup className="col-12 col-md-12 col-lg-12 col-xl-12 text-start">
                                <Label htmlFor="Username" className="title-font-500 fs-4 text-start text-black">
                                    Password Resetting For
                                </Label>
                                <input
                                    className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                                    id="fusername"
                                    {...register("fusername", { required: "Username is required *" })}
                                    name="fusername"
                                    placeholder="Enter Username..."
                                    type="email"
                                    disabled
                                />
                                {errors.fusername && <ErrorComponents error={errors.fusername?.message} />}
                                {nameFilters && <ErrorComponents error={nameFilters} />}
                            </FormGroup>
                            <div className='w-100 d-flex row'>
                                <div className='w-50'>
                                    <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                                        <Label htmlFor="examplePassword" className=" title-font-600 fs-4 text-start text-black">
                                            New Password *
                                        </Label>
                                        <div className="position-relative d-flex align-items-center w-100">
                                            <input type={passwordToggle3 ? "password" : "search"}
                                                {...register("fpassword", { required: true })}
                                                placeholder="Enter New Password..."
                                                id="fpassword"
                                                name="fpassword"
                                                className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                                            />
                                            <span className="eye-box" onClick={() => passwordShow3()}>
                                                {
                                                    eyeIcon3 !== "fa-eye" ?
                                                        <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                                        <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                                                }
                                            </span>
                                        </div>
                                        {errors.fpassword && <ErrorComponents error={"Password is required *"} />}
                                    </FormGroup>
                                </div>
                                <div className='w-50'>
                                    <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                                        <Label htmlFor="ConfirmPassword" className=" title-font-500 fs-4 text-start text-black">
                                            Confirm Password *
                                        </Label>
                                        <div className="position-relative d-flex align-items-center w-100">
                                            <input
                                                type={passwordToggle2 ? "password" : "search"} id='fpassword2'
                                                {...register("fpassword2", {
                                                    required: true,
                                                })}
                                                placeholder="Re-type Password"
                                                className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                                            />
                                            <span className="eye-box" onClick={() => passwordShow2()}>
                                                {
                                                    eyeIcon2 !== "fa-eye" ?
                                                        <i className="fa-regular fa-eye fs-3 text-base-gray"></i> :
                                                        <i className="fa-regular fa-eye-slash fs-3 text-base-gray" ></i>
                                                }
                                            </span>
                                        </div>
                                        {psserr && <ErrorComponents error={psserr} />}
                                        {errors.fpassword2 && <ErrorComponents error={errors.fpassword2?.message} />}
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>{' '}
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons'><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Reset</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default ForgotPassword